import styled from 'styled-components';
import {
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const ContainerDropdown = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`;

export const Dropdown = styled(SemanticDropdown)`
  &.ui.dropdown {
    display: flex;
    width: fit-content;
    align-items: baseline;
  }

  &.ui.dropdown>.text {
    line-height: 15px;
    color: ${(props) => props.theme.color.link};
  }
  &.ui.dropdown .menu {
    right: 0;
    left: auto;
  }
  &.ui.dropdown .menu>.item {
    text-align: end;
  }
`;

export const Menu = styled(SemanticDropdown.Menu)``;

export const Item = styled(SemanticDropdown.Item)``;

export const Icon = styled.img`
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
`;

export const TextRemove = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.deleteLink};
`;

export const ContentCenter = styled.div`
  display: flex;
  align-items: center;
`;
